import { Box, Container, Grid } from '@chakra-ui/react';
import { FC } from 'react';
import { LinkWithImage } from '../LinkWithImage';
import { OtherLinksSectionProps } from './OtherLinksSection.props';

const OtherLinksSection: FC<OtherLinksSectionProps> = ({data}) => (
  <Box
    p={{base:'10px 0', md:'30px 0'}}
    as="section" >
    <Container maxW={{ base: '1440px'}}>
      <Grid
        mt={{base:20, md:50}}
        templateColumns={{base:'unset', md:'repeat(2, 1fr)'}}
        gap={{base:3, md:10}}>
        {data?.map((item, i) => (
          <LinkWithImage
            key={item?.link?.url}
            index={i}
            image={item?.image}
            link={item?.link}
          />
        ))}
      </Grid>
    </Container>
  </Box>
);

export { OtherLinksSection };
